// The deck as a whole in the command bar (SC, Features 4): on a slides board, the slide sorter, the slide master, a
// template to start from and Design ideas for the slide in view, found by their names and the words people use for
// them ("sections", "hide", "PowerPoint's designer"). Each loads the deck's code only when run.

import { EyeOff, LayoutGrid, LayoutTemplate, Lightbulb, Shapes } from "lucide-react";
import { addCommands, type Command } from "./registry";

addCommands("slides-deck", ({ board, kind }): Command[] => {
  if (!board || board.archived || kind !== "slides") return [];
  const id = board.id;
  const view = (v: "sorter" | "master") => () => void import("../../boards/slides/master/state").then((m) => m.setView(id, v));
  return [
    { id: "deck:sorter", group: "This board", label: "Slide sorter", hint: "Every slide at once: drag, hide, sections", icon: <LayoutGrid size={15} />, keywords: "slide sorter grid overview reorder sections hide slides", run: view("sorter") },
    { id: "deck:master", group: "This board", label: "Slide master", hint: "Restyle a layout once, every slide on it follows", icon: <LayoutTemplate size={15} />, keywords: "slide master layouts title style logo footer every slide", run: view("master") },
    { id: "deck:template", group: "This board", label: "Start from a template", hint: "A pitch, an update, a kickoff, a sales deck, a lesson", icon: <Shapes size={15} />, keywords: "template templates gallery start deck pitch weekly kickoff sales lesson", run: () => void import("../../boards/slides/gallery/Gallery").then((m) => m.openGallery(id)) },
    {
      id: "deck:ideas",
      group: "This board",
      label: "Design ideas",
      hint: "Three designs for this slide's words",
      icon: <Lightbulb size={15} />,
      keywords: "design ideas designer layout suggestions redesign slide",
      run: () => void Promise.all([import("../../boards/slides/master/state"), import("../../boards/slides/ideas/Ideas")]).then(([s, i]) => (s.setView(id, "normal"), i.openIdeas())),
    },
    {
      id: "deck:hide",
      group: "This board",
      label: "Hide or show this slide",
      hint: "Skipped when presenting",
      icon: <EyeOff size={15} />,
      keywords: "hide slide show slide skip presenting hidden",
      run: () =>
        void Promise.all([import("../../boards/slides/sorter/actions"), import("../../boards/slides/state"), import("../../boards/slides/deck")]).then(([a, st, d]) => {
          const open = st.useSlidesUi.getState().open[id] ?? d.slidesNow(id)[0]?.id;
          const e = open ? d.slidesNow(id).find((x) => x.id === open) : null;
          if (e) a.hideSlides(id, [e.id], e.data.hidden !== true);
        }),
    },
  ];
});
